<template>
  <!--begin::Review Listing-->
  <div class="review-template">
    <PageHeaderCount
      moduleType="review"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_reviews"
      countkey="review_status_count"
    ></PageHeaderCount>
    <ListingTemplate
      :customClass="'review-listing'"
      v-if="getPermission('reviews:view')"
    >
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <v-flex class="pt-0 mxw-200">
              <h1 class="form-title d-flex margin-auto">Reviews</h1>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex
              class="pt-0 justify-flex-end d-flex margin-auto all-project-btn-right"
            >
              <!-- <v-autocomplete hide-details v-model.trim="filter_rating" :items="ratingOptions" clearable
                style="max-width: 200px !important" dense flat filled placeholder="Rating Filter" item-color="cyan"
                color="cyan" solo :disabled="dataLoading" :loading="dataLoading" v-on:change="getRows()"
                item-value="value" item-text="text">
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title v-html="'No Ratings Found.'"></v-list-item-title>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item }">
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="text-capitalize font-weight-500 font-size-16">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete> -->

              <v-btn
                :disabled="dataLoading"
                depressed
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="searchDialog = true"
              >
                <v-icon dark>mdi-filter</v-icon>
              </v-btn>

              <v-btn
                :disabled="dataLoading"
                depressed
                class="mx-2 custom-bold-button"
                color="cyan white--text"
                v-on:click="exportReviews"
              >
                <v-icon dark left>mdi-database-export</v-icon> Export
              </v-btn>

              <v-menu
                max-height="400"
                max-width="250"
                offset-y
                left
                :close-on-content-click="false"
                content-class="white-background"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="dataLoading"
                    depressed
                    class="mx-2 custom-bold-button btn-tab-hide"
                    color="cyan white--text"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-table-edit</v-icon>
                  </v-btn>
                </template>
                <draggable
                  tag="ul"
                  v-model="defaultColDefs"
                  class="draggable-group"
                  handle=".draggable-drag-icon"
                  v-on:change="updateVisible()"
                >
                  <template v-for="cols in defaultColDefs">
                    <li class="draggable-group-item" :key="cols.field">
                      <v-checkbox
                        dense
                        v-model="defaultColShow"
                        v-bind:value="cols.field"
                        :label="cols.headerName"
                        :disabled="Number(cols.fixed) || dataLoading"
                        color="cyan"
                        hide-details
                        class="mt-0 mb-0"
                        v-on:change="updateVisible()"
                      ></v-checkbox>
                      <v-icon class="draggable-drag-icon" right color="cyan"
                        >mdi-drag</v-icon
                      >
                    </li>
                  </template>
                </draggable>
              </v-menu>
              <PageTips v-if="false" module="review"></PageTips>
            </v-flex>
          </template>
        </ListingHeader>

        <!-- Export notifications -->
        <v-alert
          v-model="alert.show"
          :type="alert.type"
          dismissible
          border="left"
          colored-border
          elevation="2"
          class="mb-4"
        >
          {{ alert.message }}
        </v-alert>

        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Review"
          :basicSearchFields="[
            'barcode',
            'customer_name',
            'Job Number',
            'Job Title',
            'Comments',
          ]"
          :allowedSearchFields="searchableArray"
          @clear-customer-filters="clearCustomerFilters"
        >
        </ListingSearchCriteria>

        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{
                        'pointer-events-none': lodash.isEmpty(rowData),
                      }"
                    >
                      <div
                        v-if="cols.sortable"
                        class="simple-table-text sortable"
                        v-on:click="
                          !dataLoading
                            ? updateSorting({
                                field: cols.field,
                                sort: cols.sort,
                              })
                            : 'javascript:void(0)'
                        "
                      >
                        {{ cols.headerName }}
                      </div>
                      <div v-else class="simple-table-text">
                        {{ cols.headerName }}
                      </div>

                      <template v-if="cols.sort">
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'asc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-ascending</v-icon
                        >
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'desc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-descending</v-icon
                        >
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>

            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!lodash.isEmpty(rowData)">
                  <tr
                    v-for="(data, index) in rowData"
                    :key="index"
                    link
                    class="review-listing-row"
                    v-on:click="rowClicked(data)"
                  >
                    <template v-for="cols in customThead">
                      <td
                        v-if="cols.visible"
                        :key="cols.id"
                        class="simple-table-td"
                      >
                        <template v-if="cols.field == 'review_number'">
                          <Barcode :barcode="data.barcode" />
                        </template>

                        <template v-else-if="cols.field == 'customer_name'">
                          <div class="review-listing-customer">
                            <div class="d-flex align-center">
                              <v-avatar size="32" class="mr-2">
                                <v-img
                                  :src="getCustomerImage(data.customer)"
                                  :lazy-src="$defaultProfileImage"
                                ></v-img>
                              </v-avatar>
                              <div>
                                <div class="font-weight-500">
                                  {{ getCustomerName(data.customer) }}
                                </div>
                                <div class="text--secondary font-size-12">
                                  {{ getCustomerEmail(data.customer) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'job_info'">
                          <div class="review-listing-job">
                            <p class="m-0 custom-nowrap-ellipsis font-size-12">
                              {{ data.visit ? data.visit.barcode : "N/A" }}
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'job_title'">
                          <div class="review-listing-job">
                            <p class="m-0 custom-nowrap-ellipsis font-size-12">
                              {{ data.visit ? data.visit.title : "N/A" }}
                            </p>
                          </div>
                        </template>

                        <template v-else-if="cols.field == 'loyalty_recomm'">
                          <div class="review-listing-job">
                            <p class="m-0 font-size-12">
                              <strong>Recommendation Score:</strong>
                              {{ data.loyalty_recomm ?? "N/A" }}/10
                            </p>

                            <p class="m-0 font-size-12">
                              <strong>Use Again:</strong>
                              {{ data.use_again || "N/A" }}
                            </p>
                          </div>
                        </template>

                        <!-- <template v-else-if="cols.field == 'comments'">
                          <div class="review-listing-comments" style="max-width: 300px">{{ data.comments }}</div>
                        </template> -->

                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.user)"
                            :data="data"
                          >
                            <template v-slot:display_name>
                              {{ data.user?.display_name || "System" }}
                            </template>
                            <template v-slot:date_time>
                              <template v-if="getDateCountAll(data.added_at)">{{
                                formatRelativeDate(data.added_at)
                              }}</template>
                              <template v-else>{{
                                formatDateTime(data.added_at)
                              }}</template>
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDate(data.added_at) }}
                              {{ formatTime(data.added_at) }}
                            </template>
                          </TableActivity>
                          <div v-else>
                            <v-chip small outlined color="blue" label>
                              {{ formatDateTime(data.added_at) }}
                            </v-chip>
                          </div>
                        </template>

                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td :colspan="15" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no reviews at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>

        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>

        <!-- Search Dialog -->
        <Dialog :commonDialog="searchDialog">
          <template v-slot:title>Filter Reviews</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <!-- Review Number Dropdown -->
                  <v-col md="6">
                    <v-text-field
                      v-model.trim="listingSearch.barcode"
                      dense
                      filled
                      label="Review #"
                      hide-details
                      solo
                      flat
                      clearable
                      color="cyan"
                    ></v-text-field>
                  </v-col>

                  <!-- Customer Name Dropdown -->
                  <v-col md="6">
                    <v-autocomplete
                      v-model="listingSearch.customer_name"
                      :items="customerOptions"
                      dense
                      filled
                      hide-details
                      label="Customer Name"
                      solo
                      flat
                      clearable
                      color="cyan"
                      :loading="loadingFilters"
                      :disabled="loadingFilters"
                      item-text="text"
                      item-value="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            >No customers found</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!-- Job ID Dropdown -->
                  <v-col md="6">
                    <v-autocomplete
                      v-model="listingSearch.job_id"
                      :items="jobIdOptions"
                      dense
                      filled
                      hide-details
                      label="Job"
                      solo
                      flat
                      clearable
                      color="cyan"
                      :loading="loadingFilters"
                      :disabled="loadingFilters"
                      item-text="barcode"
                      item-value="barcode"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            >No barcodes found</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!-- Date Range -->
                  <v-col md="6">
                    <DateRangePicker
                      v-model="listingSearch.dates"
                      range
                      solo
                      label="Date Range"
                      :nullable="true"
                      :clearable="true"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Review Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { QUERY } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
import JwtService from "@/core/services/jwt.service";
import moment from "moment";

export default {
  mixins: [CommonMixin, ListingMixin],
  name: "review-listing",
  data() {
    return {
      pageModule: "review-listing",
      routeAPI: "reviews",
      routeName: "review.listing",
      routeDetailName: "review.detail",
      customThead: [],
      filter_rating: null,
      sortBy: null,
      sortOrder: null,

      // Add these to prevent multiple calls
      isInitialized: false,
      apiCallInProgress: false,

      // Initialize as null, will be set in created()
      debouncedGetRows: null,

      // Filter options
      loadingFilters: false,
      reviewNumberOptions: [],
      customerOptions: [],
      jobIdOptions: [],
      engineerOptions: [],

      statusList: [
        {
          text: "All Reviews",
          value: "all",
          color: "blue",
          textcolor: "white",
          all_reviews: 0,
        },
      ],

      ratingOptions: [
        { text: "All Ratings", value: "all" },
        { text: "5 Stars", value: 5 },
        { text: "4 Stars", value: 4 },
        { text: "3 Stars", value: 3 },
        { text: "2 Stars", value: 2 },
        { text: "1 Star", value: 1 },
      ],

      searchableArray: ["barcode", "customer_name", "job_id", "dates"],

      // v-alert state
      alert: {
        show: false,
        type: "info", // info | success | error | warning
        message: "",
      },
      searchEnabled: false,
    };
  },

  components: {
    draggable,
    PageTips,
    Barcode,
    PageHeaderCount,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    DateRangePicker,
  },

  created() {
    this.debouncedGetRows = this.lodash.debounce(this.getRows.bind(this), 300);
  },

  methods: {
    getFilteredVisits(row) {
      return Array.isArray(row?.ticket?.visit)
        ? row.ticket.visit.filter((v) => v && v.barcode)
        : [];
    },

    formatDateTime(date) {
      if (!date) return "-";

      return moment(date).format("DD/MM/YYYY hh:mm A");
    },

    // Load filter options
    async loadFilterOptions() {
      if (this.loadingFilters) return;

      this.loadingFilters = true;

      try {
        const response = await this.$store.dispatch(QUERY, {
          url: "reviews/filter-options",
          data: {},
        });
        if (response && response.success) {
          this.reviewNumberOptions = response.data.review_numbers || [];
          this.customerOptions = response.data.customers || [];
          this.jobIdOptions = response.data.job_ids || [];
          this.engineerOptions = response.data.engineers || [];
        }
      } catch (error) {
        console.error("Error loading filter options:", error);
      } finally {
        this.loadingFilters = false;
      }
    },

    getRows() {
      // Prevent multiple simultaneous calls
      if (this.apiCallInProgress) {
        return;
      }

      const _this = this;
      _this.apiCallInProgress = true;
      _this.dataLoading = true;

      const queryParams = {
        per_page: _this.paginationPageSize,
        page: _this.currentPage,
        sort_by: _this.sortBy || "added_at",
        sort_order: _this.sortOrder || "desc",
      };

      if (_this.filter_rating && _this.filter_rating !== "all") {
        queryParams.rating = _this.filter_rating;
      }

      if (_this.$route?.query?.search) {
        queryParams.search = _this.$route?.query?.search;
      }

      if (_this.listingSearch) {
        if (_this.listingSearch.barcode) {
          queryParams.barcode = _this.listingSearch.barcode;
        }

        if (_this.listingSearch.customer_name) {
          queryParams.customer_name =
            _this.customerOptions.find(
              (item) => item.text == _this.listingSearch.customer_name
            )?.value || null;
        }

        if (_this.listingSearch.job_id) {
          queryParams.job_id =
            _this.jobIdOptions.find(
              (item) => item.barcode == _this.listingSearch.job_id
            )?.value || null;
        }

        if (_this.listingSearch.engineer_id) {
          queryParams.engineer_id =
            _this.engineerOptions.find(
              (item) => item.text == _this.listingSearch.engineer_id
            )?.value || null;
        }
        if (
          _this.listingSearch.dates &&
          Array.isArray(_this.listingSearch.dates)
        ) {
          const dates = _this.listingSearch.dates
            .map((date) => _this.formatDateForAPI(date))
            .filter(Boolean);
          if (dates.length) {
            queryParams.dates = dates;
          }
        }
      }

      // Make the API call
      _this.$store
        .dispatch(QUERY, {
          url: _this.routeAPI,
          data: queryParams,
        })
        .then((response) => {
          if (response && response.success) {
            // Set row data
            _this.rowData = response.data || response.rows || [];

            // Set pagination data
            if (response.pagination) {
              _this.currentPage = response.pagination.current_page;
              _this.totalPages = response.pagination.last_page;
              _this.totalRows = response.pagination.total;
              _this.rowsOffset = response.pagination.from
                ? response.pagination.from - 1
                : 0;
            } else {
              _this.totalRows = response.total || response.total_rows || 0;
              _this.totalPages = Math.ceil(
                _this.totalRows / _this.paginationPageSize
              );
              _this.rowsOffset =
                (_this.currentPage - 1) * _this.paginationPageSize;
            }

            // Update status counts
            if (response.status_counts) {
              _this.updateStatusCounts(response.status_counts);
            }

            if (Array.isArray(response.theads) && response.theads.length) {
              _this.defaultColDefs = response.theads.map((h) => ({
                headerName: h.headerName,
                field: h.field,
                type: h.type,
                sort: h.sort,
                visible: !!h.visible,
                fixed: !!h.fixed,
                sortable: !!h.sortable,
                order: typeof h.order === "number" ? h.order : 0,
                width: h.width || null,
                checkbox: !!h.checkbox,
                internal: !!h.internal,
                id: h.id,
              }));

              // Apply visibility state
              const visibleCols = _this.defaultColDefs.filter(
                (col) => col.visible
              );
              _this.defaultColShow = visibleCols.map((col) => col.field);
              _this.customThead = visibleCols;
            }

            _this.dataLoading = false;
            _this.apiCallInProgress = false;
          } else {
            _this.setEmptyData();
          }
        })
        .catch((error) => {
          console.error("Error fetching reviews:", error);
          _this.resetData();
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
          _this.apiCallInProgress = false;
        });
    },

    // Filter rows method - called when Filter button is clicked
    filterRows() {
      // Reset to first page when filtering
      this.currentPage = 1;

      // Build query params for the route - this is crucial for search criteria
      const queryParams = {};

      // Add rating filter to route query
      if (this.filter_rating && this.filter_rating !== "all") {
        queryParams.rating = this.filter_rating;
      }

      // Add all search parameters to route query
      if (this.listingSearch) {
        Object.keys(this.listingSearch).forEach((key) => {
          const value = this.listingSearch[key];

          if (key === "dates" && Array.isArray(value)) {
            if (value[0]) {
              queryParams["dates[0]"] = this.formatDateForAPI(value[0]);
            }
            if (value[1]) {
              queryParams["dates[1]"] = this.formatDateForAPI(value[1]);
            }
          } else if (value !== null && value !== "" && value !== undefined) {
            queryParams[key] = value;
          }
        });
      }

      // Update the route with query params - this is what makes search criteria work
      this.$router.replace({ query: queryParams }).catch(() => {});

      // Close dialog
      this.searchDialog = false;

      // Enable search criteria display
      this.searchEnabled = true;

      // Fetch rows with new filters
      this.getRows();
    },
    updateSearchFromRoute() {
      const _this = this;

      // Clear existing search
      _this.listingSearch = {};

      // Extract search parameters from route query
      const query = _this.$route.query;

      if (query && Object.keys(query).length > 0) {
        // Handle rating filter
        if (query.rating && query.rating !== "all") {
          _this.filter_rating = query.rating;
        }

        // Handle other search fields
        _this.searchableArray.forEach((field) => {
          if (field === "dates") {
            // Handle date range
            if (query["dates[0]"] || query["dates[1]"]) {
              _this.listingSearch.dates = [
                query["dates[0]"] || null,
                query["dates[1]"] || null,
              ];
            }
          } else if (query[field]) {
            _this.listingSearch[field] = query[field];
          }
        });

        // Enable search criteria if any filters are present
        _this.searchEnabled = _this.hasActiveFilters();
      }
    },
    // Helper method to check if any filters are active
    hasActiveFilters() {
      // Check rating filter
      if (this.filter_rating && this.filter_rating !== "all") {
        return true;
      }

      // Check listingSearch object
      if (this.listingSearch && Object.keys(this.listingSearch).length > 0) {
        return Object.keys(this.listingSearch).some((key) => {
          const value = this.listingSearch[key];
          if (key === "dates") {
            return (
              Array.isArray(value) && value.length > 0 && (value[0] || value[1])
            );
          }
          return value !== null && value !== "" && value !== undefined;
        });
      }

      // Check route query as fallback
      const query = this.$route.query;
      if (query && Object.keys(query).length > 0) {
        const hasRelevantParams = this.searchableArray.some((field) => {
          if (field === "dates") {
            return query["dates[0]"] || query["dates[1]"];
          }
          return query[field];
        });
        const hasRatingFilter = query.rating && query.rating !== "all";
        return hasRelevantParams || hasRatingFilter;
      }

      return false;
    },
    getFilterLabel(field) {
      // Map field names to human-readable labels
      const fieldLabels = {
        barcode: "Review #",
        customer_name: "Customer Name",
        job_id: "Job ID",
        dates: "Date Range",
      };

      return fieldLabels[field] || this.lodash.startCase(field);
    },
    // Clear all filters
    clearCustomerFilters() {
      // Clear everything
      this.listingSearch = {};
      this.filter_rating = null;
      this.currentPage = 1;
      if (this.$route?.query?.search) {
        this.$route.query.search = null;
      }

      // Reset sorting
      this.sortBy = null;
      this.sortOrder = null;

      // Clear column sorts
      this.defaultColDefs.forEach((col) => {
        col.sort = null;
      });

      // Clear route query - this is important for search criteria
      this.$router.replace({ query: {} }).catch(() => {});

      // Disable search criteria
      this.searchEnabled = false;

      // Refresh data
      this.getRows();

      // Close dialogs
      this.searchDialog = false;
    },

    // Helper method to format dates for API
    formatDateForAPI(date) {
      if (!date) return null;

      // If it's already a string in YYYY-MM-DD format, return as is
      if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }

      // Convert to YYYY-MM-DD format
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // Helper method to set default columns
    setDefaultColumns() {
      this.customThead = this.defaultColDefs.filter((col) => col.visible);
      this.updateColumnVisibility();
    },

    // Helper method to reset data on error
    resetData() {
      this.rowData = [];
      this.totalRows = 0;
      this.totalPages = 0;
      this.rowsOffset = 0;
    },

    // Update column visibility
    updateColumnVisibility() {
      if (this.defaultColDefs && this.defaultColDefs.length) {
        this.customThead = this.defaultColDefs.filter((col) =>
          this.defaultColShow.includes(col.field)
        );
        this.defaultColShow = this.customThead.map((col) => col.field);
      }
    },

    // Update status counts method
    updateStatusCounts(statusCounts) {
      const _this = this;
      _this.statusList.forEach((status) => {
        if (status.value === "all") {
          status.all_reviews = statusCounts.all_reviews || 0;
        }
      });
    },

    getCustomerImage(customer) {
      if (
        customer &&
        customer.profile_logo &&
        customer.profile_logo.file &&
        customer.profile_logo.file.url
      ) {
        return customer.profile_logo.file.url;
      }
      return this.$defaultProfileImage;
    },

    getCustomerName(customer) {
      if (customer) {
        if (customer.company_type === "company") {
          return customer.display_name || customer.company_name;
        } else {
          return customer.default_person
            ? customer.default_person.display_name
            : customer.display_name;
        }
      }
      return "N/A";
    },

    getCustomerEmail(customer) {
      if (customer) {
        if (customer.company_type === "company") {
          return customer.company_email;
        } else {
          return customer.default_person
            ? customer.default_person.primary_email
            : "";
        }
      }
      return "";
    },

    getEngineerDisplayName(engineer) {
      if (engineer.display_name) {
        return engineer.display_name;
      } else if (engineer.first_name || engineer.last_name) {
        return `${engineer.first_name || ""} ${
          engineer.last_name || ""
        }`.trim();
      } else {
        return `Cleaner #${engineer.id}`;
      }
    },

    exportReviews() {
      (async () => {
        try {
          let downloadURL = process.env.VUE_APP_API_URL + "reviews/export";
          downloadURL = new URL(downloadURL);

          const token = JwtService.getToken();
          if (token) {
            downloadURL.searchParams.append("token", token);
          }

          // Add rating filter
          if (this.filter_rating && this.filter_rating !== "all") {
            downloadURL.searchParams.append("rating", this.filter_rating);
          }
          // Add all search parameters
          if (this.listingSearch) {
            if (this.listingSearch.review_number) {
              downloadURL.searchParams.append(
                "review_number",
                this.listingSearch.review_number
              );
            }
            if (this.listingSearch.customer_name) {
              downloadURL.searchParams.append(
                "customer_name",
                this.listingSearch.customer_name
              );
            }
            if (this.listingSearch.job_id) {
              downloadURL.searchParams.append(
                "job_id",
                this.listingSearch.job_id
              );
            }
            if (this.listingSearch.engineer_id) {
              downloadURL.searchParams.append(
                "engineer_id",
                this.listingSearch.engineer_id
              );
            }

            // Date range
            if (Array.isArray(this.listingSearch.dates)) {
              if (this.listingSearch.dates[0]) {
                downloadURL.searchParams.append(
                  "dates[0]",
                  this.formatDateForAPI(this.listingSearch.dates[0])
                );
              }
              if (this.listingSearch.dates[1]) {
                downloadURL.searchParams.append(
                  "dates[1]",
                  this.formatDateForAPI(this.listingSearch.dates[1])
                );
              }
            }
          }

          const url = downloadURL.toString();

          const res = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${JwtService.getToken()}`,
            },
          });

          const contentType = res.headers.get("content-type") || "";

          // Check for errors
          if (contentType.includes("application/json")) {
            const data = await res.json().catch(() => ({ success: false }));
            if (data && data.success === false) {
              this.showAlert(
                "error",
                data.message || "No reviews found to export"
              );
              return;
            }
            this.showAlert("error", "Failed to export reviews");
            return;
          }

          if (!res.ok) {
            this.showAlert("error", "Failed to export reviews");
            return;
          }

          // Handle file download
          const blob = await res.blob();
          if (!blob || blob.size === 0) {
            this.showAlert("error", "No reviews found to export");
            return;
          }

          let filename = "reviews-export.xlsx";
          const cd = res.headers.get("content-disposition");
          if (cd) {
            const match = cd.match(
              /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
            );
            const name = decodeURIComponent(match?.[1] || match?.[2] || "");
            if (name) filename = name;
          }

          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(blobUrl);

          this.showAlert("success", "Reviews exported successfully!");
        } catch (error) {
          console.error("Export error:", error);
          this.showAlert("error", "Failed to export reviews");
        }
      })();
    },

    // Column visibility methods
    // updateVisible() {
    //   this.customThead = this.defaultColDefs
    //     .filter((col) => this.defaultColShow.includes(col.field))
    //     .map((col) => ({
    //       ...col,
    //       visible: true,
    //     }));
    // },

    // Method to get date count for relative date display
    getDateCountAll(date) {
      return moment().diff(moment(date), "days") < 7;
    },

    // Show a dismissible alert with auto-hide
    showAlert(type, message, timeout = 5000) {
      this.alert.type = type;
      this.alert.message = message;
      this.alert.show = true;
      if (this._alertTimer) clearTimeout(this._alertTimer);
      if (timeout) {
        this._alertTimer = setTimeout(() => {
          this.alert.show = false;
        }, timeout);
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Reviews",
      },
    ]);
    if (!this.isInitialized) {
      this.isInitialized = true;
      // Load filter options when component mounts
      this.loadFilterOptions();
      // Small delay to ensure everything is ready
      this.$nextTick(() => {
        this.getRows();
      });
    }
  },

  beforeMount() {
    const _this = this;

    _this.lodash.assign(_this.queryParams, _this.$route.query);

    // Start with no static columns; rely on API-provided theads
    _this.defaultColDefs = [];
    _this.defaultColShow = [];
    _this.customThead = [];

    _this.filter_rating = _this.$route.query.rating || _this.filter_rating;

    _this.applyColState();

    _this.paginationPageSize =
      parseInt(window.localStorage.getItem(_this.pageModule)) || 50;
  },

  watch: {
    filter_rating: {
      handler(newVal, oldVal) {
        // Only trigger if component is initialized and value actually changed
        if (
          this.isInitialized &&
          newVal !== oldVal &&
          !this.apiCallInProgress
        ) {
          this.currentPage = 1;
          // Use debounced version to prevent rapid calls
          this.debouncedGetRows();
        }
      },
    },

    // Watch for search dialog opening to load filter options
    searchDialog: {
      handler(newVal) {
        if (
          newVal &&
          !this.loadingFilters &&
          this.reviewNumberOptions.length === 0
        ) {
          this.loadFilterOptions();
        }
      },
    },
  },
};
</script>

<style scoped>
.review-listing-row {
  cursor: pointer;
}

.review-listing-row:hover {
  background-color: #f5f5f5;
}

.review-listing-customer,
.review-listing-job,
.review-listing-details,
.review-listing-comments,
.review-listing-engineers {
  min-width: 150px;
}

.custom-nowrap-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-nowrap-ellipsis-four-line {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row-not-found-image {
  max-width: 200px;
  opacity: 0.5;
}

.draggable-group {
  list-style: none;
  padding: 0;
  margin: 0;
}

.draggable-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.draggable-drag-icon {
  cursor: grab;
}

.draggable-drag-icon:active {
  cursor: grabbing;
}
</style>
